:host {
  display: block;
}

afs-link a[data-disabled="true"] {
  cursor: not-allowed;
}

afs-link a[data-disabled="true"] > * {
  cursor: not-allowed;
}